import { Component, Input } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ModalService } from '../../../core/modal/modal.service';
import { RetailPlaceService } from '../../../core/services/retail-place.service';

@UntilDestroy()
@Component({
  selector: 'tax-remove-retail-place',
  templateUrl: './remove-retail-place.component.html',
  styleUrls: ['./remove-retail-place.component.sass'],
})

export class RemoveRetailPlaceComponent {
  @Input() retailPlaceId?: number;

  constructor(
    private modalService: ModalService,
    private retailPlaceService: RetailPlaceService,
  ) {
  }

  confirmation(retailPlaceId: number): void {
    this.retailPlaceService.deleteRetailPlace(retailPlaceId)
      .pipe(
        finalize(() => {
          this.closeModal();
        }),
        untilDestroyed(this),
      )
      .subscribe();
  }

  closeModal(): void {
    this.modalService.close();
  }
}
